import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Popup from '../Popup';
import { Field, reduxForm } from 'redux-form';
import { commonStyles } from '../../styles/styles';
import ForgottenPasswordForm from '../Form/ForgottenPasswordForm';
import Logo from '../Logo';
import forgotBg from '../../assets/forgot_image.png';
import logoLong from '../../assets/cs_long.svg';
import icon_CPS from '../../assets/icon_cps.svg';

import EmailField from '../Form/EmailField';
import { forgottenPasswordRequest, loginReset } from '../../redux/reducers/login';
import { validateForgottenPassword } from '../Form/validate';

import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput, MDBBtn, MDBIcon, MDBModalFooter, MDBNotification } from 'mdbreact';


const ForgottenPasswordPopup = ({ classes, handleLoginPopup,handleSubmit,
  submitting,
  handleSubmitForgottenPassword,
  showSuccess,
  loginReducer }) => (
  <MDBContainer fluid>
  <div className="mainBg"></div>
      <MDBRow center  style={{alignItems: 'center', display: 'flex', height: '100vh'}}>
      <MDBCol md="6" >
        <MDBCard >
        <div className="header pt-3">
              <MDBRow className="">
                <h3 className="gotham-bold w-100 lg-text mt-2 mb-2 pb-1 mx-5">
                  Forgotten Password
                </h3>
                <img className="icon_CPS" src={icon_CPS} />
              </MDBRow>
            </div>
            <MDBCardBody className="mt-4">
              <form onSubmit={handleSubmit(handleSubmitForgottenPassword)} className={classes.form}>
               
                <MDBRow center className="w-100">
                  <MDBCol lg="10" className="w-100">
                    <Field name="Email" label="Email" component={EmailField} />
                  </MDBCol>
                </MDBRow>
             <MDBRow center className="w-100 pt-4">
                <MDBCol lg="4" className="left">
                    <MDBBtn
                      color="yellow-new"
                      right
                      className='ml-auto ml-4 mt-0 w-100 mb-2'
                      action
                      type="submit"
                      disabled={submitting}>
                      Request
                    </MDBBtn>
                </MDBCol>
               
              </MDBRow>
              {loginReducer.error && loginReducer.error.response.data && <MDBNotification
        autohide={7000} // by default = ∞ ms
        bodyClassName="p-5 font-weight-bold grey-dark-text"
        className="white-color"
        closeClassName="white-text"
        fade
        icon="exclamation-triangle"
        iconClassName="white-text"
        message={loginReducer.error.response.data.message}
        show
        title="Error"
        titleClassName="secondary-color white-text"
        style={{marginBottom:30, position:'absolute'}}
      />}

{!loginReducer.error &&
      showSuccess && (
        <MDBNotification
        autohide={7000} // by default = ∞ ms
        bodyClassName="p-5 font-weight-bold grey-dark-text"
        className="white-color"
        closeClassName="white-text"
        fade
        icon="check-circle"
        iconClassName="white-text"
        message="Reset password request was sent. Please check your email."
        show
        title="Success"
        titleClassName="success-color white-text"
        style={{marginBottom:30, position:'absolute'}}
      />
      )}
            </form>
              
              
              <div className="md-text grey-text d-flex justify-content-center pt-2">
              
                <div
                  className="dark-grey-text gotham-bold ml-1"
                  onClick={event => handleLoginPopup(event)}
                  style={{cursor:'pointer'}}
                >
                  Back to Login
                </div>
              </div>
             
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  // <Popup>
  //   <div className={classes.popupWrapper}>
  //     <div className={classes.popupContainer}>
  //       <div className={classes.leftSide} style={{ backgroundImage: `url(${forgotBg})` }}>
  //         <Logo className={classes.logoPopup} wideLogo />
  //       </div>
  //       <div className={classes.rightSide}>
  //         <div className={classes.topPart}>
  //           <Typography variant="headline" gutterBottom className={classes.popupSubtitle}>
  //             Forgot Password?
  //           </Typography>
  //           <ForgottenPasswordForm />
  //           <Typography variant="caption" className={classes.registrationCaption} style={{textAlign:'center'}}>
  //           Back to&nbsp;
  //           <Typography
  //             className={classes.registrationLink}
  //             onClick={event => handleLoginPopup(event)}
  //           >
  //             Login
  //           </Typography>
  //         </Typography>
  //         </div>
         
  //       </div>
  //     </div>
  //   </div>
  // </Popup>
);

ForgottenPasswordPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  loginReducer: PropTypes.instanceOf(Object),
  submitting: PropTypes.bool,
  showSuccess: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleSubmitForgottenPassword: PropTypes.func,
};

const mapStateToProps = state => ({
  form: state.form,
  loginReducer: state.loginReducer,
});

const mapDispatchToProps = dispatch => ({
  forgottenPasswordRequest: () => dispatch(forgottenPasswordRequest()),
  loginReset: () => dispatch(loginReset()),
});

const styles = () => ({
  ...commonStyles,
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 10,
  },
});

export default compose(
  reduxForm({
    form: 'forgottenPassword',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('showSuccess', 'handleSuccessMessage', null),
  withHandlers({
    handleSubmitForgottenPassword: props => values => {
      validateForgottenPassword(values);
      props.forgottenPasswordRequest();
    },
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const { loginReducer, loginReset, handleSuccessMessage } = nextProps;
      const { responseForgottenPassword } = this.props.loginReducer;
      if (loginReducer.fetchingForgottenPassword) {
        loginReset();
      }
      if (loginReducer.responseForgottenPassword !== responseForgottenPassword) {
        handleSuccessMessage(true);
      }
    },
    componentWillUnmount() {
      if (this.props.loginReducer.error) {
        this.props.loginReset();
      }
    },
  }),
  withStyles(styles),
)(ForgottenPasswordPopup);


// WEBPACK FOOTER //
// ./src/Components/Popups/ForgottenPasswordPopup.jsx